import React, { useState } from "react";
import "./Css/Settings.css";
import Header from "./Header";
import WebRestroInfo from "./WebRestroInfo";
import "./Css/WebsiteMngmt.css";
import AddImage from "./AddImage";
import TeamWebsite from "./TeamWebsite";
import FaqBlogWebsite from "./FaqBlogWebsite";
import CapsWebsite from "./CapsWebsite";
import SeoWebsite from "./SeoWebsite";
import BlogWebsite from "./BlogWebsite";
import EventWebsite from "./EventWebsite";
import EmailSubs from "./EmailSubsView";
import VacancyWebsite from "./VacancyWebsite";
import TermsOfUse from "./TermsOfUse";
import PrivacyPolicy from "./PrivacyPolicy";
import BlogKeyword from "./BlogKeyword";
function WebsiteMngt() {
  const [restriInfo, setrestriInfo] = useState(true);
  const [addImage, setaddImage] = useState(false);
  const [blog, setblog] = useState(false);
  const [blogkey, setblogkey] = useState(false);
  const [seo, setseo] = useState(false);
  const [team, setteam] = useState(false);
  const [faqblog, sefaqblog] = useState(false);
  const [emailSubs, setemailSubs] = useState(false);
  const [terms, setterms] = useState(false);
  const [policy, setpolicy] = useState(false);
  const [events, setevents] = useState(false);
  const [caps, setcaps] = useState(false);
  const [vacancy, setvacancy] = useState(false);

  const toggleSettingsBar = (TabId) => {
    setrestriInfo(TabId === "1");
    setaddImage(TabId === "2");
    setblog(TabId === "3");
    setseo(TabId === "4");
    setteam(TabId === "5");
    setemailSubs(TabId === "6");
    setterms(TabId === "7");
    setpolicy(TabId === "8");
    setvacancy(TabId === "9");
    setblogkey(TabId === "10");
    sefaqblog(TabId === "11");
  };

  return (
    <div className="dashboard">
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="settingsTabs">
                <div className="settingsTabs_container">
                  <ul>
                    <li
                      className={`${restriInfo ? "currentTab" : ""}`}
                      onClick={() => toggleSettingsBar("1")}
                    >
                      <div className="setTab setTab1">
                        <p>Website Info</p>
                      </div>
                    </li>
                    <li className={`${addImage ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("2")}
                      >
                        <p>Add Image</p>
                      </div>
                    </li>
                    {/* <li className={`${blogkey ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("10")}
                      >
                        <p>Blog Keyword</p>
                      </div>
                    </li> */}
                    <li className={`${blog ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("3")}
                      >
                        <p>Blog</p>
                      </div>
                    </li>
                    <li className={`${seo ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("4")}
                      >
                        <p>SEO</p>
                      </div>
                    </li>
                    <li className={`${faqblog ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("11")}
                      >
                        <p>Faq Blog</p>
                      </div>
                    </li>
                    <li className={`${emailSubs ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("6")}
                      >
                        <p>Email Subs.</p>
                      </div>
                    </li>
                    {/* <li className={`${terms ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("7")}
                      >
                        <p>Terms & Condition</p>
                      </div>
                    </li> */}
                    {/* <li className={`${policy ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("8")}
                      >
                        <p>Privacy policy</p>
                      </div>
                    </li> */}
                    {/* <li className={`${vacancy ? "currentTab" : ""}`}>
                      <div
                        className="setTab setTab1"
                        onClick={() => toggleSettingsBar("9")}
                      >
                        <p>Vacancy</p>
                      </div>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="container-lg">
              {" "}
              <div className="page_body">
                <div className="settingstabsContainer">
                  {restriInfo && <WebRestroInfo />}
                  {addImage && <AddImage />}
                  {policy && <PrivacyPolicy />}
                  {seo && <SeoWebsite />}
                  {team && <TeamWebsite />}
                  {faqblog && <FaqBlogWebsite />}
                  {blogkey && <BlogKeyword />}
                  {blog && <BlogWebsite />}
                  {terms && <TermsOfUse />}
                  {emailSubs && <EmailSubs />}
                  {vacancy && <VacancyWebsite />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebsiteMngt;
